import { AxiosResponse } from "axios";
import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { S3LocationRequest, S3LocationResponse } from "@/commons/models/S3Location";
import { S3MultiLocation, S3UploadResponse } from "@/commons/models/S3MultiLocation";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * S3格納場所 API 操作クラス
 */
export default class S3Locations {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * POST S3Locations
   */
  public async post(userStore: LoginUser, requestBody: S3LocationRequest): Promise<Array<S3LocationResponse>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.S3Locations, formatParams);
    const response: AxiosResponse<Array<S3LocationResponse>> = await this.commonService.executePost<Array<S3LocationResponse>>(
      userStore,
      requestUrl,
      requestBody,
      this.constructor.name,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * POST S3MultiLocations
   */
  public async multiPost(userStore: LoginUser, requestBody: S3MultiLocation): Promise<S3UploadResponse> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.S3MultiLocations, formatParams);
    const response: AxiosResponse<S3UploadResponse> = await this.commonService.executePost<S3UploadResponse>(
      userStore,
      requestUrl,
      requestBody,
      this.constructor.name,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}
